import type { ReactNode } from 'react'

import { styled } from 'styled-components'

import { FormattedMessage } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'
import type { ListingDto } from '@b-stock/listing-api-client'
import { DocumentDtoDocTypeEnum } from '@b-stock/listing-api-client'

import { DocumentLink } from '../DocumentLink'

const Title = styled.h2`
  ${Typography.Title2}
  margin: 0;
  padding: 0;
  @media ${Breakpoints.max.small} {
    display: none;
  }
`
const SubTitle = styled.h2`
  ${Typography.Title3}
  margin: 0 0 0.5rem 0;
  padding: 0;
  @media ${Breakpoints.max.small} {
    ${Typography.Subtitle1}
  }
`

// we may not use grid
const TableContainer = styled.div`
  display: grid;
  grid-template-columns: 18rem 1fr;
  grid-gap: 1.5rem;
  @media ${Breakpoints.max.medium} {
    grid-template-columns: 1fr;
  }
`

export const DetailsValue = styled.div`
  position: relative;
  ${Typography.Body2}
`

export const InfoSection = styled.div`
  position: relative;
  margin-bottom: 5rem;
`

type PoliciesProps = {
  documents: ListingDto['documents']
  documentType: DocumentDtoDocTypeEnum
  cancellationPolicy?: string
}

const Policies = ({ documents, cancellationPolicy }: PoliciesProps) => (
  <>
    <TableContainer>
      <Title>
        <FormattedMessage id="Auction.title.policies" />
      </Title>
      <div>
        <InfoSection>
          <SubTitle>
            <FormattedMessage id="Auction.title.termsOfPurchase" />
          </SubTitle>
          <DetailsValue>
            <FormattedMessage
              id="Auction.body.policies"
              values={{
                link: (content: ReactNode) => (
                  <DocumentLink
                    documents={documents}
                    documentType={DocumentDtoDocTypeEnum.TermsOfService}
                  >
                    {content}
                  </DocumentLink>
                ),
              }}
            />
          </DetailsValue>
        </InfoSection>
        {cancellationPolicy && (
          <InfoSection>
            <SubTitle>
              <FormattedMessage id="Auction.title.cancellationPolicy" />
            </SubTitle>
            <DetailsValue>{cancellationPolicy}</DetailsValue>
          </InfoSection>
        )}
      </div>
    </TableContainer>
  </>
)

export default Policies
